module.exports = __webpack_public_path__ + "assets/img/arrow-right - Copy.5b872731.svg";